const YOUTUBE_AUTOPLAY_QUERY_PARAM = 'autoplay=1';

const appendAutoplayToYouTubeEmbedURL = (youTubeEmbedURL: string): string => {
  return `${youTubeEmbedURL}?${YOUTUBE_AUTOPLAY_QUERY_PARAM}`;
};

export default appendAutoplayToYouTubeEmbedURL;
